// Recursos de idioma carregados estaticamente (empacotados pelo Vite).
// Um arquivo por módulo em locales/{en-US,pt-BR}/<módulo>.json; paridade garantida por keys.test.ts.
import enUSAuthz from '../locales/en-US/authz.json';
import enUSCommon from '../locales/en-US/common.json';
import enUSDocuments from '../locales/en-US/documents.json';
import enUSErrors from '../locales/en-US/errors.json';
import enUSFacilities from '../locales/en-US/facilities.json';
import enUSIdentity from '../locales/en-US/identity.json';
import enUSNotifications from '../locales/en-US/notifications.json';
import enUSPeople from '../locales/en-US/people.json';
import enUSReports from '../locales/en-US/reports.json';
import enUSScheduling from '../locales/en-US/scheduling.json';
import enUSShell from '../locales/en-US/shell.json';
import enUSStudies from '../locales/en-US/studies.json';
import enUSSuppliers from '../locales/en-US/suppliers.json';
import enUSTenancy from '../locales/en-US/tenancy.json';
import enUSWorkflow from '../locales/en-US/workflow.json';
import ptBRAuthz from '../locales/pt-BR/authz.json';
import ptBRCommon from '../locales/pt-BR/common.json';
import ptBRDocuments from '../locales/pt-BR/documents.json';
import ptBRErrors from '../locales/pt-BR/errors.json';
import ptBRFacilities from '../locales/pt-BR/facilities.json';
import ptBRIdentity from '../locales/pt-BR/identity.json';
import ptBRNotifications from '../locales/pt-BR/notifications.json';
import ptBRPeople from '../locales/pt-BR/people.json';
import ptBRReports from '../locales/pt-BR/reports.json';
import ptBRScheduling from '../locales/pt-BR/scheduling.json';
import ptBRShell from '../locales/pt-BR/shell.json';
import ptBRStudies from '../locales/pt-BR/studies.json';
import ptBRSuppliers from '../locales/pt-BR/suppliers.json';
import ptBRTenancy from '../locales/pt-BR/tenancy.json';
import ptBRWorkflow from '../locales/pt-BR/workflow.json';

export const SUPPORTED_LOCALES = ['pt-BR', 'en-US'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

/** Idioma padrão e de fallback (Parte 13.1, REQ-PLT-024). */
export const DEFAULT_LOCALE: Locale = 'pt-BR';

export const namespaces = [
  'common',
  'shell',
  'errors',
  'identity',
  'tenancy',
  'authz',
  'people',
  'facilities',
  'studies',
  'suppliers',
  'documents',
  'scheduling',
  'workflow',
  'reports',
  'notifications',
] as const;
export type Namespace = (typeof namespaces)[number];

export const DEFAULT_NAMESPACE = 'common' satisfies Namespace;

const enUS = {
  common: enUSCommon,
  shell: enUSShell,
  errors: enUSErrors,
  identity: enUSIdentity,
  tenancy: enUSTenancy,
  authz: enUSAuthz,
  people: enUSPeople,
  facilities: enUSFacilities,
  studies: enUSStudies,
  suppliers: enUSSuppliers,
  documents: enUSDocuments,
  scheduling: enUSScheduling,
  workflow: enUSWorkflow,
  reports: enUSReports,
  notifications: enUSNotifications,
} as const;

const ptBR = {
  common: ptBRCommon,
  shell: ptBRShell,
  errors: ptBRErrors,
  identity: ptBRIdentity,
  tenancy: ptBRTenancy,
  authz: ptBRAuthz,
  people: ptBRPeople,
  facilities: ptBRFacilities,
  studies: ptBRStudies,
  suppliers: ptBRSuppliers,
  documents: ptBRDocuments,
  scheduling: ptBRScheduling,
  workflow: ptBRWorkflow,
  reports: ptBRReports,
  notifications: ptBRNotifications,
} as const;

/** Recursos por locale, na forma esperada por `i18next.init({ resources })`. */
export const resources = {
  'en-US': enUS,
  'pt-BR': ptBR,
} as const;

/** Forma dos recursos usada para tipar as chaves (referência: en-US). */
export type TranslationResources = typeof enUS;
